import { z } from "zod";

export const filterSourcesFormSchema = z.object({
  status: z.object({ label: z.string(), value: z.boolean().nullable() }),
  type: z.object({ label: z.string(), value: z.string().nullable() }),
  publicationType: z.object({ label: z.string(), value: z.string().nullable() }),
  contentType: z.object({ label: z.string(), value: z.string().nullable() }),
  license: z.object({ label: z.string(), value: z.string().nullable() }),
  countries: z.array(z.object({ label: z.string(), value: z.string() })),
  regions: z.array(z.object({ label: z.string(), value: z.string() })),
  greaterRegions: z.array(z.object({ label: z.string(), value: z.string() })),
});

export type FilterSourcesFormState = z.infer<typeof filterSourcesFormSchema>;
